export const getById = ({items}) => id => {
  const item = items.find(o => {
    return o.id === parseInt(id, 10);
  });

  return (item) ? item : {};
}

export const getByName = ({items}) => name => {
  const item = items.find(o => {
    return o.name === name;
  });

  return (item) ? item : {};
}

export const getBySlug = ({items}) => slug => {
  const item = items.find(o => {
    return o.slug === slug;
  });

  return (item) ? item : {};
}

export const getAll = ({items}) => {
  return items ? items : [];
}

export default {
  getById,
  getByName,
  getBySlug,
  getAll,
};
